import { Sqc } from "../../pages/SQC";
import { InternalUserRoles } from "../../constants/roles";
import { ReactComponent as SQCIcon } from "../../assets/sqcicon.svg";
import { ModuleRouteConfig, RouteConfig } from "../types";

export const BASE_PATH = "/sqc";

export const baseRoute: ModuleRouteConfig = {
  path: BASE_PATH,
  component: Sqc,
  allowedRoles: InternalUserRoles,
  label: "SQC",
  icon: () => <SQCIcon />,
  isCustomIcon: true,
  hasDivider: false,
};

export const sQCRoutes: { [key: string]: RouteConfig } = {
  sQC: baseRoute,
};
